/* Rquiere de mixin.js */

var subscription = {
	data() {
		return {
			listSubscriptions: [],
			listProductsSubscription: [],
			searchingProductsSubscription: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		generateByChurch(year, church, products, lot, entityId) {
			let data = {
				church: church,
				products: products,
				lot: lot,
				entityId: entityId
			}
			let url = this.apiBackend + 'subscription/' + year + '/church/generate'
			console.log(url, data)
			this.axiosActionIS(url, 'POST', 'generateByChurchResult', data)
		},
		generateByChurchResult(response) {
			if (response.data.success == true) {
				this.generateByChurchResultLocal(response)
			}
		},
		generateByChurchResultLocal(response) {
			console.log('generateByChurchResultLocal no desarrollado', response)
		},
		getChurchsByPendingSubscriptions(year, entityId, products) {
			this.loadingChurchs = true
			this.listChurchs = []
			let url = this.apiBackend + 'subscription/' + year + '/getChurchsByPendingSubscriptions'
			let data = {
				entity_id: entityId,
				products: products
			}
			this.axiosActionIS(url, 'POST', 'getAllChurchsResult', data)
		},
		getInvoiceShippingSubscription(idOrder) {
			let url = this.apiBackend + 'subscription/getInvoiceShippingSubscription/' + idOrder
			this.axiosActionIS(url, 'GET', 'getInvoiceShippingSubscriptionResult')
		},
		getInvoiceShippingSubscriptionResult(response) {
			this.getInvoiceShippingSubscriptionResultLocal(response)
		},
		getInvoiceShippingSubscriptionResultLocal(response) {
			console.log('getInvoiceShippingSubscriptionResult no desarrollado', response)
		},
		getPendingSubscriptions(year) {
			this.listSubscriptions = []
			let url = this.apiBackend + 'subscription/' + year + '/getPendingSubscriptions'
			this.axiosActionIS(url, 'GET', 'getPendingSubscriptionsResult')
		},
		getPendingSubscriptionsResult(response) {
			if (response.data.success == true) {
				this.listSubscriptions = response.data.data
			}
			this.getPendingSubscriptionsResultLocal(response)
		},
		getPendingSubscriptionsResultLocal(response) {
			console.log('getPendingSubscriptionsResultLocal no desarrollado', response)
		},
		getProductSubscriptionByYear(subscriptionId) {
			let url = this.apiBackend + 'products/subscription/' + subscriptionId + '/priceList/1'
			console.log(url)
			this.axiosActionIS(this.apiBackend + 'products/subscription/' + subscriptionId + '/priceList/1', 'GET', 'getProductSubscriptionByYearResult', null)
		},
		getProductSubscriptionByYearResult(response) {
			if (response.data.success === true) {
				this.listProductsSubscription = response.data.data
			}
			this.getProductSubscriptionByYearResultLocal(response)
		},
		getProductSubscriptionByYearResultLocal(response) {
			console.log('getProductSubscriptionByYearResultLocal no desarrollado', response)
		},
		getSubscriptionDetail(id) {
			let url = this.apiBackend + 'subscription/getSubscriptionDetail/' + id
			console.log(url)
			this.axiosActionIS(url, 'GET', 'getSubscriptionDetailResult', null)
		},
		getSubscriptionDetailResult(response) {
			this.getSubscriptionDetailResultLocal(response)
		},
		getSubscriptionDetailResultLocal(response) {
			console.log('getSubscriptionDetailResultLocal no desarrollado', response)
		},
	},
};

export default subscription;